<template>
  <el-row>
    <b v-if="row.name">
      {{ row.name }}
      <span>{{ row.standard }}</span>
      <i v-if="!readonly && isSlave" type="text" class="el-icon-delete danger pointer left-pad"
        @click="$emit('delete', row)"></i>
    </b>
    <div v-else>
      <el-select ref="draftSelector" :popper-append-to-body="false" @change="(val) => optionSelected(val, row)"
        style="width: 90%" size="small" v-model="options.selected" filterable placeholder="请选择" remote
        :filter-method="optionSearch" value-key="code" default-first-option>
        <el-option v-for="item in options.drug" :key="item.id" :label="item.name" :value="item"
          style="font-size: 1rem; width: 50rem">
          <el-row :gutter="0"
            :title="`厂商：${item.manufacturerCode} 批次：${item.lotNumber || '无'} 有效期：${item.expirationDate}`">
            <el-col :span="1"><small class="primary">药品</small></el-col>
            <el-col :span="14" style="white-space: pre-line">
              <span>{{ item.name }}</span>
              <small>{{ item.standard }}</small>
            </el-col>
            <el-col :span="4" class="right danger">￥{{ item.price | fmtFloat }}</el-col>
            <el-col :span="3" class="left">
              <span class="left-pad">{{ item.type | dictText("DrugType") }}</span>
            </el-col>
            <el-col :span="2" class="right primary">{{ item.quantity }} {{ item.unit }}</el-col>
          </el-row>
        </el-option>
      </el-select>
      <i v-if="!readonly && isSlave" type="text" class="el-icon-delete danger pointer left-pad"
        @click="$emit('delete', row)"></i>
    </div>
    <el-row v-if="!readonly && row.name">
      <template>
        <el-input ref="dosageInput" v-hic-select size="small" class="edit-thin right-pad" v-model="row.dosagePerTime"
          placeholder="用量" @keydown.enter.native="dosageChanged" @change="dosageChanged" type="number">
          <div slot="suffix" style="margin-top: 4px">{{ row.dosageUnit || row.minUnit }}/次</div>
        </el-input>
      </template>
      <el-input ref="quantityInput" v-model="row.quantity" placeholder="数量" type="number" size="small"
        class="edit-thin right-pad" @keydown.enter.native="quantityChanged" @change="quantityChanged" v-hic-select>
        <div slot="suffix" style="margin-top: 4px">{{ row.unit }}</div>
      </el-input>

      <hic-dict-selector ref="usageSelector" v-if="isMaster && !(isGroup && row.id)" v-model="row.usage"
        dict-type="DrugUsage" placeholder="用法" class="edit-thin right-pad" @change="usageChanged" />

      <hic-dict-selector ref="frequencySelector" v-if="isMaster" v-model="row.frequency" dict-type="DrugFrequency"
        placeholder="频次" style="width: 16rem" class="right-pad" @change="frequencyChanged" />

      <el-input ref="dropSpeedInput" v-if="groupable && isMaster && isDrip" v-model="row.drops" size="small"
        style="width: 5rem" @keydown.enter.native="dropSpeedChanged" v-hic-select><span slot="suffix"
          class="suffix">滴/分</span></el-input>
    </el-row>
    <el-row v-if="readonly">
      <span class="right-pad">
        用量：<b class="danger">{{ row.dosagePerTime }} {{ row.dosageUnit || row.minUnit }}</b>
      </span>
      <span class="right-pad">
        数量：<b class="danger">{{ row.quantity }} {{ row.unit }}</b>
      </span>
      <span class="right-pad">
        用法：<b class="danger">{{ row.usage | dictText("DrugUsage") }}</b>
      </span>
      <span v-if="!isGroup" class="right-pad">
        频次：<b class="danger">{{ row.frequency | dictText("DrugFrequency") }}</b>
      </span>
      <!-- <span v-if="!isGroup" class="right-pad">
        周期：<b class="danger">{{ row.cycles }}{{ currUnit }}</b>
      </span> -->
    </el-row>
    <el-tag type="info" hit v-if="groupable && isMaster" style="border-left: #409eff 120px solid" class="top-pad">
      <span style="margin: 0 10px 0 -120px; color: white">{{ groupable }}【{{ row.groupNo || row.id }}】</span>
      <span class="left-pad">
        <b>频次：</b><b class="danger">{{ row.frequency | dictText("DrugFrequency") }}</b>
      </span>
      <!-- <span v-if="isMaster" class="left-pad">
        <b>周期：</b><b :class="isMaster ? 'danger' : 'info'">{{ row.days }}</b>
      </span> -->
      <span v-if="isDrip" class="left-pad">
        <b>滴速：</b><b class="danger">{{ row.drops }} 滴/分</b>
      </span>
    </el-tag>
    <el-button v-if="!readonly && row.id && groupable && isMaster" type="primary" circle plain size="mini"
      icon="el-icon-plus" class="left-pad" @click="add" />

    <template v-if="row.items">
      <editorDrug :isTmpl="isTmpl" v-for="(item, index) in row.items" :key="index" :row="item" :readonly="row.readonly"
        class="top-pad" :storehouse-code="storehouseCode" @delete="deleteItem(item, index)" />
    </template>
  </el-row>
</template>
<script>
import { mapGetters } from "sw-hic";
import api from "../api";
export default {
  props: {
    row: Object,
    storehouseCode: String,
    isTmpl: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    editorDrug: () => import("./_editorDrug.vue"),
  },
  data() {
    return {
      options: {
        drug: [],
        selected: null,
        standardNum: 1
      },
    };
  },
  computed: {
    ...mapGetters(["user", "dict"]),
    usage() {
      // 用法
      if (!this.row.usage) {
        return {};
      }
      let usage = this.dict.DrugUsage.find((u) => u.code == this.row.usage);
      if (!usage) {
        return {};
      }
      if (usage.extra) {
        try {
          usage.extraObj = JSON.parse(usage.extra);
        } catch (error) {
          console.log(error);
        }
      }
      return usage;
    },
    groupable() {
      // 是不是可分组，如果是直接返回分组类型
      return this.usage?.extraObj?.groupable;
    },
    isDrip() {
      // 是不是输液
      return this.usage?.extraObj?.isDrip;
    },
    isMaster() {
      if (!this.row.groupNo) {
        return true;
      }
      return this.row.groupNo == this.row.id;
    },
    isSlave() {
      return !this.isMaster;
    },
    isGroup() {
      return !!this.row.groupNo;
    },
    currFrequency() {
      if (this.row?.frequency) {
        return this.dict.DrugFrequency.find((f) => f.code == this.row.frequency) || {};
      }
      return {};
    },
    currUnit() {
      if (this.currFrequency.extra) {
        return JSON.parse(this.currFrequency.extra).unit || "次";
      }
      return "次";
    },
    readonly() {
      if (this.isTmpl) return true;
      return this.row.state !== "草稿" && this.row.state !== "退回";
    },
  },
  inject: {
    // 注入父类方法
    proto: {
      from: "proto",
      default: () => ({}),
    },
    patchAdvice: {
      from: "patchAdvice",
      default: () => ({}),
    },
    calculateQuantity: {
      from: "calculateQuantity",
      default: () => ({}),
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.draftSelector) this.$refs.draftSelector.focus();
      if (this.$refs.dosageInput) this.$refs.dosageInput.focus();

      this.standardNum = this.row.dosagePerTime / this.row.quantity
    });
  },
  methods: {
    save(part, partObj) {
      // 医嘱主记录返回上层保存
      if (this.isMaster) {
        if (part) {
          this.$emit("partChange", this.row[part], this.row, part, partObj);
        } else {
          this.$emit("ok", this.row);
        }
        return;
      }
      // 从医嘱直接保存
      api.Advice.save(this.row).then((res) => {
        this.row.id = res.id;
        this.row.lockKey = res.lockKey;
        this.$message.success("保存成功！");
      });
    },
    add() {
      // 添加从医嘱
      if (!this.row.groupNo) {
        this.$set(this.row, "groupNo", this.row.id);
      }

      let item = {};
      this.$utils.Obj.propertyCopy(this.row, item, ["state", "hospitalizationId", "ipNo", "deptCode", "wardCode", "bedNo", "patientCode", "patientName", "babyPatientCode", "babyPatientName", "doctorCode", "doctorName", "type", "term", "startTime", "endTime", "rpClass", "execDeptCode", "groupNo"]);
      item.claimType = "医保内";
      if (!this.row.items) this.row.items = [];
      this.row.items.push(item);
    },
    quantityChanged(val) {
      if (isNaN(this.row.quantity) || Number(this.row.quantity) <= 0) {
        console.log("数量有误！");
        return;
      }
      this.$nextTick(() => {
        this.row.dosagePerTime = this.formatNumber(parseFloat( this.row.quantity * this.standardNum).toFixed(2))
        if (this.row.id) {
          this.save("quantity");
          return;
        }

        // 从医嘱直接保存（因为其它属性和主医嘱一致）
        if (this.$refs.usageSelector) {
          this.$refs.usageSelector.focus();
        } else {
          this.save();
        }
      });
    },
    usageChanged(val) {
      if (!val) {
        return;
      }
      this.$nextTick(() => {
        if (this.row.id) {
          this.save("usage");
        }
        this.$refs.frequencySelector.focus();
      });
    },
    dosageChanged() {
      if (isNaN(this.row.dosagePerTime) || Number(this.row.dosagePerTime) <= 0) {
        return;
      }
      this.$nextTick(() => {
        this.row.quantity = this.formatNumber(parseFloat(this.row.dosagePerTime / this.standardNum).toFixed(2))
        if (this.row.id) {
          this.save("dosagePerTime");
        }
        if (this.$refs.quantityInput) {
          this.$refs.quantityInput.focus();
        } else {
          this.save();
        }
      });
    },
    /**
   * 格式化数字显示规则：
   * 1. 整数 → 只显示整数位
   * 2. 小数第二位是0 → 显示1位小数
   * 3. 其他情况 → 显示2位小数
   * @param {Number|String} num - 要格式化的数字（支持数字/字符串类型）
   * @returns {String} 格式化后的数字字符串
   */
    formatNumber(num) {
      // 第一步：校验并转换为数字，处理空值/非数字情况
      const number = Number(num);
      if (isNaN(number)) {
        return '0'; // 非数字默认返回0
      }

      // 第二步：先保留2位小数（处理精度问题）
      const fixed2 = number.toFixed(2);

      // 第三步：拆分整数和小数部分
      const [integerPart, decimalPart] = fixed2.split('.');

      // 第四步：按规则判断显示格式
      // 小数部分第二位是0
      if (decimalPart[1] === '0') {
        // 小数部分第一位也是0 → 整数
        if (decimalPart[0] === '0') {
          return integerPart;
        }
        // 只显示1位小数
        return `${integerPart}.${decimalPart[0]}`;
      }

      // 其他情况显示2位小数
      return fixed2;
    },
    frequencyChanged(val) {
      if (!val) {
        return;
      }
      let frequency = this.dict.DrugFrequency.find((f) => f.code == val) || {};
      this.$set(this.row, "times", frequency.frequencyTimes || 1);
      this.$set(this.row, "dailyTime", frequency.dailyTime || "0000");

      this.$nextTick(() => {
        if (this.row.id) {
          this.save("frequency", {
            id: this.row.id,
            times: this.row.times,
            // dailyTime: this.row.dailyTime, //todo
            frequency: val,
          });
          if (this.$refs.dropSpeedInput) {
            this.$refs.dropSpeedInput.focus();
          }
        } else {
          if (this.$refs.dropSpeedInput) {
            this.$refs.dropSpeedInput.focus();
          } else {
            this.save();
          }
        }
        // this.$refs.daysInput.focus();
      });
    },
    dropSpeedChanged(val) {
      this.$nextTick(() => {
        if (this.row.id) {
          this.save("drops");
        } else {
          this.save();
        }
      });
    },
    optionSearch(keyword) {
      api.Drug.getDrugs({
        pageSize: 10,
        keyword,
        storehouseCode: this.storehouseCode,
        sort: "sortNum",
      }).then((res) => {
        this.options.drug = res.items;
      });
    },
    optionSelected(option, draft) {
      if (option.storehouseCode && option.restrict) {
        if ((this.user.drugRestrict || []).findIndex((r) => r.code == option.restrict) < 0) {
          return this.$message.error("您暂时无权限开具此药品！");
        }
      }
      this.$utils.Obj.propertyCopy(
        option,
        draft,
        [
          "rpClass",
          "code",
          "insuranceCode",
          "claimType",
          "name",
          "standard",
          "unit",
          "quantity",
          "approvalNumber",
          "lotNumber",
          "form",
          "manufacturerCode",
          "feeType",
          "restrict",
          "cost",
          "price",
          "frequency",
          "times",
          "dosagePerTime",
          "dosageUnit",
          "totalDose",
          "usage",
          "drops",
          "itemType",
          "symptom",
          "parts",
          "checkWays",
          "execDeptCode",
          "content",
          "ifHomeDrug",
          "ifOneTimeCharge",
          "ifStandby",
          "decoction",
          "dosage",
          "contraindication",
          "specialUsage",
          "purpose",
          "ifEmergency",
          "specimenType",
          "storehouseCode",
        ],
        this
      );
      if (option.type == 0) this.$set(draft, "feeType", "07") //西药
      else if (option.type == 1) this.$set(draft, "feeType", "09") //中成药
      else if (option.type == 2) this.$set(draft, "feeType", "08") //中草药

      this.$set(draft, "detail", JSON.stringify(option));
      this.$set(draft, "id", null);
      if (option.storehouseCode) {
        this.$set(draft, "type", "药品");
        this.$set(draft, "rpClass", "药品");
        this.$set(draft, "usage", option.usage);
        this.$set(draft, "quantity", 1);
        this.$set(draft, "dosagePerTime", option.dosages);
        this.$set(draft, "srcId", option.id); // 库存ID
      } else {
        this.$set(draft, "type", "医技");
      }
      this.$nextTick(() => {
        if (this.$refs.dosageInput) this.$refs.dosageInput.focus();
      });
    },
    deleteItem(item, idx) {
      if (!item.id) {
        this.row.items.splice(idx, 1);
        return;
      }
      api.Advice.del(item.id).then(() => {
        this.row.items.splice(idx, 1);
      });
    },
  },
};
</script>
